import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    timeout: _ctx.timeout,
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.show) = $event)),
    vertical: true,
    class: "snackbar-survey",
    location: 'bottom',
    "multi-line": true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_btn, {
        icon: "$close",
        density: "compact",
        onClick: _ctx.closeSurveyResponse,
        color: "white",
        variant: "text",
        class: "survey-close-button",
        title: "Fermer"
      }, null, 8, ["onClick"]),
      _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-center" }, "Votre avis compte !", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", null, " En 2 minutes répondez à notre questionnaire et aidez-nous à améliorer votre expérience sur bobbee ! ", -1))
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "space-between" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "text-start" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_checkbox, {
                label: "Ne plus afficher",
                modelValue: _ctx.doNotShowAgain,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.doNotShowAgain) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { class: "text-end valign-middle" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                onClick: _ctx.goToSurvey,
                variant: "flat",
                slim: false,
                class: "survey-button"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Je donne mon avis ")
                ])),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["timeout", "modelValue"]))
}